export default {
    fundLists:'/index.php/cqh/Fund/fundLists',//市级项目资金列表
    addFund:'/index.php/cqh/Fund/addFund',//添加修改项目资金
    deleteFund:'/index.php/cqh/Fund/deleteFund',//删除项目资金记录
    fundDetail:'/index.php/cqh/Fund/fundDetail',//市级项目资金详情
    confirmFund:'/index.php/cqh/Fund/confirmFund',//资金拨款确认
    listNotFund:'/index.php/cqh/Project/listNotFund',//市级项目资金项目列表
    projectMoneyOut:'/index.php/cqh/Project/projectMoneyOut',//项目资金导出
}